export default __webpack_public_path__ + "static/media/vinai.1b0bfded.svg";